import React from "react";

export const SubscribeStarIcon: React.FC = () => {
  return (
    <svg
      aria-label="SubscribeStar"
      viewBox="64 64 384 384"
      xmlns="http://www.w3.org/2000/svg"
      width="1rem"
      height="1rem"
    >
      <path
        fill="currentColor"
        d="m256 64a192 192 0 0 0-4.6973 0.33594c18.083 20.899 52.788 42.77 69.697 62.664 18 21 36 48 36 83 0 23.75-2.7196 40.212-6.4199 51.236 2.8872 11.578 4.4199 24.321 4.4199 38.764l-1 31h-66v-8.9043c-6.3004 0.40314-28.044 5.0509-52.949 1.0293 9.1752 26.941 89.462 74.631 100.83 106.58a192 192 0 0 0 112.12-173.71 192 192 0 0 0-192-192zm79.881 365.71a192 192 0 0 1-7.1484 3.5625c2.4229-1.0499 4.8456-2.107 7.2676-3.2695-0.0331-0.09628-0.08478-0.1964-0.11914-0.29297zm-159.59-348.37a192 192 0 0 0-0.28711 0.14844c0.09399-0.050058 0.19259-0.098552 0.28711-0.14844zm-1.2754 0.6875a192 192 0 0 0-111.01 173.98 192 192 0 0 0 192 192 192 192 0 0 0 3.7363-0.26758c-20.008-20.902-50.809-40.818-67.736-60.732-18-22-35-48-35-84 0-24 1-41 6-52 1.2268 7.7697 3.4608 15.093 6.4824 21.924-7.4923-18.455-9.4824-39.058-9.4824-56.924v-35l66 1v10c8-2 17-3 27-3 9.0826 0 17.546 0.68843 25.416 2.0527-24.3-40.413-79.585-64.396-103.4-109.03z"
      />
      <path
        fill="currentColor"
        d="m260 448c-20-21-51-41-68-61-18-22-35-48-35-84 0-24 1-41 6-52 6 38 35 66 72 72 9 27 90 75 101 107-25 12-50 18-76 18zm-34-256c8-2 17-3 27-3 35 0 61 10 78 31 16 21 24 46 24 80l-1 31h-66v-26c1-16-1-30-6-38-6-10-20-10-29-10-17 1-28-17-27-30v-35z"
        fillOpacity=".5"
      />
    </svg>
  );
};
